/**
 * Class Ratchet
 *
 * @author Jeremie Nogues
 * @year 2024
 * @filename ratchet.js
 * @location /js/my
 */

export default class Ratchet {
	/**
	 * Constructor
	 */
	constructor() {
		this.websocket = null;
	}
	/**
	 * Initialise le websocket
	 */
	initSocketListeners(appContext) {

		//si le websocket est fourni
		if (php_to_js_vars.websocket && php_to_js_vars.token) {
			//creation des objets
			const objCalibration = appContext.get("objCalibration");
			const objCommons = appContext.get("objCommons");
			const objEvaluation = appContext.get("objEvaluation");
			const objEntrainement = appContext.get("objEntrainement");
			const objMenu = appContext.get("objMenu");
			const objTchat = appContext.get("objTchat");
			const objSeances = appContext.get("objSeances");
			const objPassations = appContext.get("objPassations");
			const objPatients = appContext.get("objPatients");

			//conecte le websocket
			this.websocket = new WebSocket(php_to_js_vars.websocket + "?token=" + encodeURIComponent(php_to_js_vars.token));

			//que faire quand l'user recois un message
			this.websocket.onmessage = function (e) {
				const data = JSON.parse(e.data);

				//quelle commande
				switch (data.command) {
					case "tchat_eleve":
					case "message":
					{
						//si c'est un enseignant
						const isEnseignant = ["enseignant", "enseignant_test", "formateur"].includes(php_to_js_vars.statut);
						if (isEnseignant) {

							//vérifie si l'élève affiché est concerné
							let isEleveCible = false;
							if (data.command === "message" && Array.isArray(data.ids_eleves)) {
								isEleveCible = data.ids_eleves.includes(objTchat.currentIdEleve);
							}

							//si le tchat est visible et que l'élève est celui affiché
							const isTchatVisible = document.getElementById("tchat").style.display === "block";
							if (isTchatVisible && isEleveCible) {
								objTchat.refreshTchatEleve();
							} else {
								objTchat.refreshTchatEnseignant(false);
							}
						} else {
							objTchat.refreshTchatEleve();
						}
						break;
					}
					case "delete_message":
						objTchat.confirmDelete(data.id_message);
						break;
					case "update_statut_calibration":
						//si l'élève est sur la page d'accueil
						if (js_page_name === "eleveAccueil") {

							//rafraichi les séances
							objSeances.refresh();
						} else {
							//rafraichi le statut de la calibration
							objPassations.refreshStatutCalibration(data.statut);
						}
						break;
					case "update_statut_evaluation":
						//si l'élève est sur la page d'accueil
						if (js_page_name === "eleveAccueil") {

							//rafraichi les séances
							objSeances.refresh();
						} else {
							//rafraichi le statut de l'évaluation
							objPassations.refreshStatutEvaluation(data.statut);
						}
						break;
					case "update_statut_entrainement":
						//si l'élève est sur la page d'accueil
						if (js_page_name === "eleveAccueil") {

							//rafraichi les séances
							objSeances.refresh();
						} else {
							//rafraichi le statut de l'entrainement
							objPassations.refreshStatutEntrainement(data.statut);
						}
						break;
					case "update_etablissement":
						//si l'user est sur la création de groupes
						if (js_page_name === "groupesCreer") {
							location.reload();
						}
						break;
					case "passation_calibration":
						//si on est bien sur la page des calibrations
						if (js_page_name === "calibrationsSeance") {

							//rafraichi le tableau avec les calibrations
							objCalibration.refreshCalibrations();
						}
						break;
					case "passation_evaluation":
						//si on est bien sur la page des évaluations
						if (js_page_name === "evaluationsSeance") {

							//rafraichi le tableau avec les évaluations
							objEvaluation.refresh();
						}
						break;
					case "passation_entrainement":
						//si on est bien sur la page des entrainements
						if (js_page_name === "entrainementsSeance" || js_page_name === "entrainementsTutore") {

							//rafraichis les cases de couleurs
							objEntrainement.refreshTableauItems();

							//regarde si un item est affiché
							if (document.getElementById("show_item").style.display === "block") {

								//vérifie qu'il s'agit du bon entrainement
								if ((js_page_name === "entrainementsSeance" && objEntrainement.currentItem.idEntrainement == data.id_eleve) || js_page_name === "entrainementsTutore") {

									//vérifie s'il s'agit de l'item passé
									if (objEntrainement.currentItem.id == data.id_item && objEntrainement.currentItem.timestampReset == data.timestamp) {

										//délai de quelques microseconds pour refresh
										setTimeout(() => {

											//lance la fonction de mise à jour des reponses
											objEntrainement.refreshReponsesItem();
										}, 300);
									}
								}
							}
						}
						break;
					case "passation_patient":
						//si on est bien sur la page domicile
						if (js_page_name === "patientsDomicile") {

							//rafraichis les cases de couleurs
							objPatients.refreshTableauItems();

							//regarde si l'item est affiché
							if (document.getElementById("show_item").style.display === "block" && objPatients.currentIdItem == data.id_item) {

								//délai de quelques microseconds pour refresh
								setTimeout(() => {

									//lance la fonction de mise à jour des reponses
									objPatients.refreshReponsesItem();
								}, 300);
							}
						}
						break;
					case "eleve_login":
					case "eleve_logout":
						//refresh le tchat entier
						objTchat.refreshTchatEnseignant(false);
						break;
					case "eleve_force_logout":
						//si c'est un élève connecté
						if (php_to_js_vars.statut === "eleve" || php_to_js_vars.statut === "etudiant") {
							//déconnecte
							objMenu.logout();
						}
						break;
					case "eleve_delete_eval":
						//si c'est un élève connecté
						if (php_to_js_vars.statut === "eleve" || php_to_js_vars.statut === "etudiant") {
							//retourne a la liste des séances
							location.href = php_to_js_vars.url + "eleve/accueil";
						}
						break;
					case "user_login":
						//vérifie s'il faut déconnecter l'user
						objCommons.checkAilleurs();
						break;
					default:
						console.warn("[WS] Command inconnue:", data.command, data);
						break;
				}
			};

			//à la fermeture
			this.websocket.onclose = () => {
				this.websocket = null;
			};

			//en cas d'erreur
			this.websocket.onerror = () => {
				console.error("[WS] ERROR", e);
			};

			//ferme le socket
			window.addEventListener("beforeunload", () => {
				if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
					this.websocket.close();
					delete this.websocket;
				}
			});
		}
	}
	/**
	 * Envoie une commande
	 * 
	 *  @param {obj} data -> contenu de la commande
	 * 
	 */
	sendCommand(data) {
		//si le websocket est fourni
		if (php_to_js_vars.websocket && php_to_js_vars.token) {

			//si le websocket est pas prêt
			if (!this.websocket || this.websocket.readyState !== WebSocket.OPEN) {

				//relance la commande
				setTimeout(() => {
					this.sendCommand(data);
				}, 500);
			} else {
				//envoie la commande
				this.websocket.send(JSON.stringify(data));
			}
		}
	}
}